import {EditOrderItems} from 'app/features/orders/componentsv1/edit'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from 'setup'
import * as model from 'app/features/orders/redux/order/helper'
import * as action from 'app/features/orders/redux/order/refundSlice'
import find from 'lodash/find'
import React, {useEffect} from 'react'

interface Props {
  onValidate: (val: any) => void
  children: React.ReactNode
}

export const RefundOrderLineItems: React.FC<Props> = ({onValidate, children}) => {
  const dispatch = useDispatch()
  const orderItems = useSelector<RootState, any[]>(action.selectRefundItems)
  const deletedItems = useSelector<RootState, any[]>(action.selectDeletedItems)
  const isValidating = useSelector<RootState, boolean>(action.selectIsValidatingDiscount)

  useEffect(() => {
    dispatch(action.updateRefundOrderSummary(deletedItems))
  }, [dispatch, deletedItems])

  const findItem = (orderItem: any) => {
    const item = find(orderItems, {variantId: orderItem.variantId})
    const deletedItem = find(deletedItems, {variantId: orderItem.variantId})
    return {item, deletedItem}
  }

  const handleRestoreItem = (orderItem: any) => {
    onRemoveDeletedItem(orderItem.variantId)
    const item = find(orderItems, {variantId: orderItem.variantId})
    if (!item) {
      dispatch(action.addOrderItem(orderItem))
    } else {
      onUpdateItem({
        ...orderItem,
        quantity: parseInt(item.quantity) + parseInt(orderItem.quantity),
      })
    }
    onValidate(true)
  }

  const onUpdateItem = (orderItem: any) => {
    dispatch(
      action.updateOrderItem({
        id: orderItem.variantId,
        changes: {
          quantity: parseInt(orderItem.quantity),
        },
      })
    )
  }

  const onRemoveDeletedItem = (variantId: string) => {
    dispatch(action.setDeletedItems({type: model.actionType.remove, data: variantId}))
  }

  const onUpdateDeleteItem = (orderItem: any, quantity: number) => {
    dispatch(
      action.setDeletedItems({
        type: model.actionType.update,
        data: {...orderItem, quantity},
      })
    )
  }

  const handleUpdateDeleteItem = (orderItem: any) => {
    orderItem.quantity = parseInt(orderItem.quantity)
    const {item, deletedItem} = findItem(orderItem)
    let add
    if (deletedItem.quantity) {
      add = orderItem.quantity > deletedItem.quantity
    }
    if (!item) {
      dispatch(action.addOrderItem({...orderItem, quantity: 1}))
    } else if (item.quantity === 1 && add) {
      dispatch(action.removeOrderItem(orderItem.variantId))
    } else {
      const quantity = add ? -1 : +1
      onUpdateItem({...orderItem, quantity: parseInt(item.quantity) + quantity})
    }
    if (orderItem.quantity > 0) {
      onUpdateDeleteItem(orderItem, orderItem.quantity)
    } else if (orderItem.quantity === 0) {
      onRemoveDeletedItem(orderItem.variantId)
    }
    onValidate(true)
  }

  return (
    <>
      {deletedItems.length > 0 && (
        <EditOrderItems
          isRefundMode
          title={<>To Be Refunded </>}
          hideSearchBar
          items={deletedItems}
          onRemoveItem={handleRestoreItem}
          onUpdateItem={handleUpdateDeleteItem}
          isRefundDiscountValidate={isValidating}
        >
          {children}
        </EditOrderItems>
      )}
    </>
  )
}

export default RefundOrderLineItems
